var _path, _path2, _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleOuter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 51,
    viewBox: "0 0 61 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.857849 25.5L17 11.3579L31.1421 25.5L17 39.6421L0.857849 25.5Z",
    fill: "#FFCA24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47528 25.5L16.7611 14.7364L27.5247 25.5L16.7611 36.2636L4.47528 25.5Z",
    fill: "#A77403"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1422,
    y: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_10924_273)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8244,
    y: 3.1823,
    width: 44.6354,
    height: 44.6354,
    rx: 22.3177,
    fill: "url(#paint1_linear_10924_273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10924_273",
    x1: 35.1422,
    y1: 0.5,
    x2: 35.1422,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D79200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10924_273",
    x1: 35.1421,
    y1: 3.1823,
    x2: 35.1421,
    y2: 47.8177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF085"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B81A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOuter);
export default ForwardRef;